<template>
<div id="vy_body">
  <div id="vy_grid">
    <div id="vy_left_nav" class="p-4">
      <!--左サイドバー-->
      <ShakyoLeftbar v-on:call="call"/>
    </div>
    <div id="vy_main">
      <main>
        <component v-bind:is="content"
                   v-bind:param="param"
                   v-on:call="call">{{ title }}</component>
        <!--フッター-->
        <FooterArea v-on:call="call"/>
      </main>
    </div>
    <div id="vy_right_nav" class="p-4">
        <!--右サイドバー-->
        <ShakyoRightBar v-on:call="call"/>
    </div>
  </div>
</div>
</template>

<script setup>
/* eslint-disable */
import ShakyoHome from './ShakyoHome.vue'
import ShakyoInputCSV from './ShakyoInputCSV.vue'
import ShakyoLeftbar from './ShakyoLeftBar.vue'
import ShakyoRightBar from './ShakyoRightBar.vue'
import FooterArea from '../common/FooterArea.vue'
import { GlobalData, login_check } from '../js/userdata_shakyo.js';
import { useRouter, useRoute } from 'vue-router'
import { shallowRef, watch } from 'vue'
import axios from 'axios'
const url = GlobalData.$API_URL
const content = shallowRef('')
const router = useRouter();
const route = useRoute();
let param = {}
login_check()
let title = "トップページ"

router.push("/"+route.params.shakyo+"/Kanri/home")
//-------------- URLが変わった時に対応する処理を起動するためのフック -----------------
const wt = watch(route, () => {
    param = { cmd:route.params.cmd, id:route.params.id }
    call(param)
})

//-------------- URLに応じた処理のコンポーネントを呼び出す -------------------
const call = function(proc) {
    switch(proc.cmd) {
        case "home":

        default:

    }
}
</script>
